/**
 * Search history — persists last-5 unique search terms in localStorage.
 * A plain listen-store instead of Zustand because usage is trivial and
 * we don't need reactivity beyond a small subscribe API.
 */
const KEY = 'luminex:search-history';
const MAX = 5;

const load = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter(x => typeof x === 'string') : [];
  } catch { return []; }
};

let history = load();
const listeners = new Set();

const emit = () => listeners.forEach(fn => { try { fn(history); } catch { /* noop */ } });

export const getSearchHistory = () => history;

export const addSearchTerm = (term) => {
  const t = (term || '').trim();
  if (t.length < 2) return;
  // Dedupe (case-insensitive) while keeping the most-recent-first order.
  const lower = t.toLowerCase();
  history = [t, ...history.filter(x => x.toLowerCase() !== lower)].slice(0, MAX);
  try { localStorage.setItem(KEY, JSON.stringify(history)); } catch { /* noop */ }
  emit();
};

export const clearSearchHistory = () => {
  history = [];
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
  emit();
};

export const subscribeSearchHistory = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
